import { debounce, each } from "lodash";
import { onLargeScreen } from "./breakpoint-detect";

declare const jQuery: any;
const $ = jQuery;
const openClassName = "open";
const $body = $("body");

const openFuncs: Function[] = [];
const closeFuncs: Function[] = [];

if (!window["iw"])
{
	window["iw"] = {};
}

const mainMenuGlobals = window["iw"].mainMenu = {
	open: () => each(openFuncs, fn => fn()),
	close: () => each(closeFuncs, fn => fn())
};

export function init(): void
{
	const $navs = $(".main-header-nav");

	if ($navs.length < 1)
	{
		return;
	}

	$navs.each(function eachNav() {
		const $nav = $(this);
		const $menu = $nav.find(".main-header-nav-main");
		const $hamburger = $nav.closest(".main-header-row").find(".hamburger, .hamburger-spinner").not(".no-menu");
		const close = () => {
			closeMenu($menu, $hamburger);
		};

		$nav.click(function onNavClick(event) {
			event.stopPropagation();
		});

		$menu.find(".main-header-nav-close").click(close);

		$body.click(close);

		$hamburger.on("click", e => {
			if (isOpen($menu))
			{
				closeMenu($menu, $hamburger);
			}
			else
			{
				openMenu($menu, $hamburger);
			}
			e.stopPropagation();
			return false;
		});

		window.addEventListener("hashchange", () => {
			closeMenu($menu, $hamburger);
			window.location.hash = "#/";
		});

		window.addEventListener("resize", debounce(() => {
			if (onLargeScreen())
			{
				$menu.stop(true).css({ opacity: "" });
			}
		}, 100));

		openFuncs.push(() => openMenu($menu, $hamburger));
		closeFuncs.push(() => closeMenu($menu, $hamburger));
	});
}

function isOpen($menu: any): boolean
{
	return $menu.hasClass(openClassName);
}

function findSubmenus($container: any): any
{
	return $container.find("ul.sub-menu");
}

function openMenu($menu: any, $hamburger: any): void
{
	if (!isOpen($menu))
	{
		$menu.trigger("beforeopen");
		$hamburger.addClass("is-active");
		$menu.stop(true).css("opacity", 0).addClass(openClassName).animate({ opacity: 1 }, 300).trigger("open");
	}
}

function closeMenu($menu: any, $hamburger: any): void
{
	if (isOpen($menu))
	{
		$menu.trigger("beforeclose");
		$hamburger.removeClass("is-active");
		$menu.stop(true).animate({ opacity: 0 }, 300, function afterAnim() {
			$menu.removeClass(openClassName);
			findSubmenus($menu).stop(true).removeClass(openClassName);
			$menu.trigger("close");
		});
	}
}
